import { useState } from 'react';
import { Route, Switch as RouterSwitch, useParams, useRouteMatch } from 'react-router-dom';

import { useNewCluster } from ':cloud/contexts/NewClusterContext';
import { useGetWorkflowByKey } from ':cloud/queries/WorkflowQueries/useGetWorkflows';
import { IWorkflow } from ':cloud/types/ts_types';
import { AppRoute } from ':cloud/utils/routes';
import CreateClusterBilling from ':cloud/widgets/billing/CreateClusterBilling';
import { Layout } from ':cloud/widgets/layout';
import { LoadingSpinner } from ':cloud/widgets/sharedcomponents';

import { CreateClusterSideRail } from './CreateClusterSideRail';
import CustomWizardForm from './CustomWizardForm';
import { Transition } from './Transition';

export function CreateCluster() {
  const { protocolKey } = useParams<{ protocolKey: string }>();
  const match = useRouteMatch();

  const newCluster = useNewCluster();

  const { workflow, isLoading: isWorkflowLoading } = useGetWorkflowByKey(protocolKey);
  const [selectedWorkflow] = useState<IWorkflow | undefined>(workflow);

  if (!selectedWorkflow || isWorkflowLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Layout>
      {newCluster.isDeploying ? (
        <Layout.MainContainer fullWidth>
          <Transition />
        </Layout.MainContainer>
      ) : (
        <>
          <Layout.MainContainer>
            {match.isExact && selectedWorkflow && (
              <CustomWizardForm selectedWorkflow={selectedWorkflow} />
            )}
            <RouterSwitch>
              <Route exact path={AppRoute.Participate.Review}>
                <CreateClusterBilling cluster={newCluster} />
              </Route>
            </RouterSwitch>
          </Layout.MainContainer>
          <Layout.SidebarContainer>
            <CreateClusterSideRail protocolKey={protocolKey} />
          </Layout.SidebarContainer>
        </>
      )}
    </Layout>
  );
}
